import { Application } from '@monorepo/types';
import { createTheme, Theme as MuiTheme } from '@mui/material';
import { stepsTheme } from './steps/steps.theme';
import { alertTheme } from './alert';
import { autocompleteTheme } from './autocomplete';
import { baseThemeConfig } from './base-theme-config';
import { breadcrumbsTheme } from './breadcrumbs';
import { buttonTheme } from './button';
import { cardTheme } from './card';
import { checkboxTheme } from './checkbox';
import { chipTheme } from './chip';
import { dataGridTheme } from './data-grid';
import { dialogTheme } from './dialog';
import { muiTipTapTheme } from './mui-tiptap';
import { popoverTheme } from './popover';
import { radioTheme } from './radio';
import { skeletonTheme } from './skeleton';
import { tableTheme } from './table';
import { textFieldTheme } from './textField';
import { the5ersColorSchemes, ttpColorSchemes } from './themes';
import { toggleButtonTheme } from './toggleButtons';
import { tooltipTheme } from './tooltip';

const colorSchemes = {
  [Application.THE5ERS]: the5ersColorSchemes,
  [Application.TTP]: ttpColorSchemes,
};

export const createAppTheme = (
  app: Application = Application.THE5ERS,
): MuiTheme => {
  return createTheme({
    colorSchemes: colorSchemes[app],
    ...baseThemeConfig,

    cssVariables: {
      colorSchemeSelector: 'data',
    },
    components: {
      ...baseThemeConfig.components,
      ...buttonTheme,
      ...cardTheme,
      ...radioTheme,
      ...chipTheme,
      ...breadcrumbsTheme,
      ...tooltipTheme,
      ...cardTheme,
      ...toggleButtonTheme,
      ...autocompleteTheme,
      ...textFieldTheme,
      ...alertTheme,
      ...tableTheme,
      ...dataGridTheme,
      ...stepsTheme,
      ...checkboxTheme,
      ...dialogTheme,
      ...skeletonTheme,
      ...dialogTheme,
      ...popoverTheme,
      ...muiTipTapTheme,
    },
  });
};
